.g-header-wrapper(style=`background-color: ${bannerColor}; color: ${textColor}`)
  .g-app-title #{brandName}

  form.g-quick-search-form(role="form")
    .form-group.g-quick-search-container

  .g-current-user-wrapper
  .g-clear-both
